import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_STEP_TEMPLATES = `${TASK_SERVICE}/step-templates`;

export const stepTemplates = {
  getByModule: async ({ module, filters, sort, top, skip } = {}) => {
    const options = await apiOptions({
      url: `${API_STEP_TEMPLATES}/${module}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
};
